import { render, staticRenderFns } from "./StepBasicEditor.vue?vue&type=template&id=a299b280&scoped=true"
import script from "./StepBasicEditor.vue?vue&type=script&lang=js"
export * from "./StepBasicEditor.vue?vue&type=script&lang=js"
import style0 from "./StepBasicEditor.vue?vue&type=style&index=0&id=a299b280&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a299b280",
  null
  
)

export default component.exports